// extracted by mini-css-extract-plugin
module.exports = {"productShowcase":"styles_productShowcase__1YAo7","btn":"styles_btn__27280"};